<template>
  <div>
    <CrudList
      title="Notification Prices"
      storeName="Notification_prices"
      :canAdd="false"
      :canEdit="false"
      :canDelete="true"
      sortable
      canSearch
    >
      <template v-slot:created_at="{ item }">
        <v-row >
          <v-col cols="8">
            <h4>{{ timeZone(item.created_at) }}</h4>
          </v-col>
        </v-row>
      </template>
      <template v-slot:show_all="{item}">
        <v-btn color="primary" @click="$router.push('/admin/notification_prices/edit/'+item.id)" >
          show
          <v-icon class="ml-2"> fa fa-eye </v-icon>
        </v-btn>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    methods: {
      timeZone(date){
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        return date.toLocaleString('en-US', { timeZone: timezone });
      }
    }
  };
</script>
